<template><ProductDetailBase route-key="/products/220kv" /></template>
<script>
import ProductDetailBase from "./ProductDetailBase.vue";
export default { name: "Product220Page", components: { ProductDetailBase } };
</script>
